import { render } from "./hotel_carousel.vue?vue&type=template&id=8eb5f430"
import script from "./hotel_carousel.vue?vue&type=script&lang=js"
export * from "./hotel_carousel.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__